exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.dataCells, .headerCells {\n  display: flex;\n}\n.printEmail h4 {\n  font-size: 1.2em;\n  font-weight: bold;\n}\n.dataCells div {\n  overflow: hidden;\n  min-height: 1.2em;\n}\n.problem {\n  color: red;\n}\n.headerCells div {\n  background-color: gainsboro;\n  border: 1px white solid;\n}\n.dataCells div {\n  border: 1px gainsboro solid;\n}\n", ""]);

// exports
